<template>
  <div class="filtro">
    <el-button :class="classe" plain @click="$emit('clickButton')">
      {{ name }} <span class="badge" v-if="ativos > 0">{{ ativos }}</span>
       <i class="el-icon-arrow-down"></i>
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'Filtro',
  props: {
    name: {
      type: String
    },
    classe: {
      type: String
    },
    ativos: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped>
.badge {
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 2px 5px;
  margin-right: 5px;
  font-size: 10px;
  font-weight: bold;
  min-width: 20px;
  text-align: center;
}
</style>
